import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { OrganizationForUpdateDto } from '../types';
import { OrganizationKeys } from './organization.keys';

export const updateOrganization = (
  id: string | undefined,
  data: OrganizationForUpdateDto,
): Promise<void> => {
  if (id === null || id === undefined) {
    throw new Error('id is required');
  }
  return clients.admin.put(`/organizations/${id}`, data);
};

export function useUpdateOrganization(
  id: string | undefined,
  options?: UseMutationOptions<void, AxiosError, OrganizationForUpdateDto>,
) {
  const queryClient = useQueryClient();

  return useMutation((data: OrganizationForUpdateDto) => updateOrganization(id, data), {
    onSuccess: () => {
      queryClient.invalidateQueries(OrganizationKeys.lists());
      queryClient.invalidateQueries(OrganizationKeys.details());
    },
    onError: (error) => {
      console.error(error);
    },
    ...options,
  });
}
